import { useEffect, useState } from "react";
import { Menu, X, Flame } from "lucide-react";
import { buildWaLink, RESTAURANT_NAME } from "../data/menu";
import WaIcon from "./WaIcon";

const NAV = [
    { id: "home", label: "Home" },
    { id: "menu", label: "Menu" },
    { id: "about", label: "About" },
    { id: "contact", label: "Contact" },
];

export const Header = () => {
    const [open, setOpen] = useState(false);
    const [scrolled, setScrolled] = useState(false);

    useEffect(() => {
        const onScroll = () => setScrolled(window.scrollY > 16);
        window.addEventListener("scroll", onScroll);
        onScroll();
        return () => window.removeEventListener("scroll", onScroll);
    }, []);

    return (
        <header
            className={`sticky top-0 z-50 w-full transition-all duration-300 ${
                scrolled
                    ? "bg-[#FDFBF7]/90 backdrop-blur-xl border-b border-[#EADEC9] shadow-sm"
                    : "bg-transparent border-b border-transparent"
            }`}
            data-testid="site-header"
        >
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 h-16 md:h-20 flex items-center justify-between">
                <a
                    href="#home"
                    className="flex items-center gap-2.5 group"
                    data-testid="brand-link"
                >
                    <span className="relative inline-flex items-center justify-center w-10 h-10 rounded-full bg-[#D35400] text-white shadow-md group-hover:scale-105 transition-transform">
                        <Flame className="w-5 h-5" />
                    </span>
                    <span className="font-display text-xl md:text-2xl font-black tracking-tight text-[#1F1A17]">
                        {RESTAURANT_NAME}
                    </span>
                </a>

                <nav className="hidden md:flex items-center gap-9">
                    {NAV.map((n) => (
                        <a
                            key={n.id}
                            href={`#${n.id}`}
                            className="text-[12px] uppercase tracking-[0.22em] font-bold text-[#1F1A17]/80 hover:text-[#D35400] transition-colors"
                            data-testid={`nav-${n.id}`}
                        >
                            {n.label}
                        </a>
                    ))}
                </nav>

                <div className="flex items-center gap-2">
                    <a
                        href={buildWaLink(
                            "Hi Kiraak Mandi! I'd like to place an order.",
                        )}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="hidden sm:inline-flex items-center gap-2 bg-[#25D366] hover:bg-[#1EBE53] text-white font-bold px-4 py-2.5 rounded-full btn-press text-sm"
                        data-testid="header-order-btn"
                    >
                        <WaIcon className="w-4 h-4" />
                        Order Now
                    </a>
                    <button
                        aria-label="Toggle menu"
                        className="md:hidden w-10 h-10 inline-flex items-center justify-center rounded-full bg-[#F5F0E6] text-[#1F1A17] btn-press"
                        onClick={() => setOpen((o) => !o)}
                        data-testid="mobile-menu-toggle"
                    >
                        {open ? <X className="w-5 h-5" /> : <Menu className="w-5 h-5" />}
                    </button>
                </div>
            </div>

            {/* Mobile drawer */}
            {open && (
                <div
                    className="md:hidden border-t border-[#EADEC9] bg-[#FDFBF7]"
                    data-testid="mobile-menu"
                >
                    <div className="px-5 py-5 flex flex-col gap-3">
                        {NAV.map((n) => (
                            <a
                                key={n.id}
                                href={`#${n.id}`}
                                onClick={() => setOpen(false)}
                                className="text-sm uppercase tracking-[0.22em] font-bold text-[#1F1A17]"
                                data-testid={`mobile-nav-${n.id}`}
                            >
                                {n.label}
                            </a>
                        ))}
                        <a
                            href={buildWaLink(
                                "Hi Kiraak Mandi! I'd like to place an order.",
                            )}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="mt-2 inline-flex items-center justify-center gap-2 bg-[#25D366] text-white font-bold px-4 py-3 rounded-full"
                            data-testid="mobile-order-btn"
                        >
                            <WaIcon className="w-4 h-4" />
                            Order on WhatsApp
                        </a>
                    </div>
                </div>
            )}
        </header>
    );
};

export default Header;
